"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckboxForm = exports.StyledCheckbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _core = require("@material-ui/core");

var _checkboxStyles = require("./checkbox-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledCheckbox = function StyledCheckbox(_ref) {
  var text = _ref.text,
      disabled = _ref.disabled,
      defaultChecked = _ref.defaultChecked,
      color = _ref.color,
      checked = _ref.checked,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_checkboxStyles.Container, null, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    disabled: disabled,
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      defaultChecked: defaultChecked,
      checked: checked,
      color: color,
      onChange: onChange
    }),
    label: text
  }));
};

exports.StyledCheckbox = StyledCheckbox;

var StyledCheckboxForm = function StyledCheckboxForm(props) {
  var input = props.input;
  return /*#__PURE__*/_react.default.createElement(StyledCheckbox, _extends({}, props, {
    name: input.name,
    checked: input.value,
    onChange: function onChange(_, value) {
      return input.onChange(value);
    }
  }));
};

exports.StyledCheckboxForm = StyledCheckboxForm;